import { gql } from '@apollo/client';

export const REMOVE_USER_FROM_RESOURCES = gql`
  mutation removeUserFromResources($userId: String!, $body: Body!) {
    removeUserFromResources(userId: $userId, body: $body)
      @rest(
        type: "RemoveUserFromResources"
        method: "POST"
        path: "/users/{args.userId}/resources/remove"
        endpoint: "admin"
        bodyKey: "body"
      ) {
      successfulDeletions {
        binders
        tenders
        organizations
      }
      failedDeletions {
        binders
        tenders
        organizations
      }
    }
  }
`;
